import { lookupGoogleMapsAddress } from '#/zustand-stores/googleMapsLibrariesStore';

type Args = {
  query: string;
  country?: string;
  state?: string;
  /**
   * Accept city-state such as Singapore
   */
  acceptCityState?: boolean;
};

export async function lookupAddressWithState({
  query,
  country,
  state,
  acceptCityState,
}: Args) {
  const place = await lookupGoogleMapsAddress({ query: query, country });
  if (!place) return {};

  const isUnitedStatesOrCanadaAddress = country === 'US' || country === 'CA';

  if (!isUnitedStatesOrCanadaAddress) {
    return {
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      latLongAddress: place.formatted_address,
      full: place.formatted_address,
    };
  }

  const stateComponent = place.address_components.find((c) =>
    c.types.includes('administrative_area_level_1'),
  );

  const stateMatches =
    stateComponent &&
    state &&
    [
      stateComponent.long_name.toLocaleLowerCase(),
      stateComponent.short_name.toLowerCase(),
    ].includes(state.toLocaleLowerCase());

  if (stateMatches) {
    return {
      stateCode: stateComponent.short_name,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      latLongAddress: place.formatted_address,
      full: place.formatted_address,
    };
  }

  if (acceptCityState && !place.types.includes('country')) {
    return {
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      latLongAddress: place.formatted_address,
    };
  }

  return {};
}
